import "core-js/modules/es.array.for-each";
import "core-js/modules/es.array.slice";
import "core-js/modules/es.object.keys";
import "core-js/modules/es.object.to-string";
import "core-js/modules/web.dom-collections.for-each";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { mapState } from 'vuex';
import { serchSelect, tabulation } from "@/mixins/index";
import { healthCheck } from "@/api/chatbot/chatbot";
export default {
  name: "operatingStatus",
  mixins: [serchSelect, tabulation],
  data: function data() {
    return {
      searchData: {
        page: 1,
        limit: 30
      },
      tableData: [],
      allTableData: [],
      hasMore: false,
      reqLoading: false
    };
  },
  created: function created() {
    this.searchClick(1);
  },
  methods: {
    searchClick: function searchClick() {
      var _this = this;

      // if (e == 1) {
      //   this.searchData.page = 1;
      // }
      this.reqLoading = true;
      healthCheck().then(function (res) {
        var datasources = Array.isArray(res) ? res : res.datasources || [];
        var processedItems = [];
        datasources.forEach(function (source) {
          processedItems.push({
            id: source.id,
            dataSourceName: source.display_name,
            checkKey: 'datasource_status',
            status: source.status || 'unknown',
            description: source.error || ''
          });
          var checks = source.checks || {};
          Object.keys(checks).forEach(function (key) {
            processedItems.push({
              id: source.id,
              dataSourceName: source.display_name,
              checkKey: key,
              status: checks[key],
              description: ''
            });
          });
        });
        _this.tableData = processedItems; //this.renderCurrentPageData();
      }).catch(function (err) {
        console.error(err);
        _this.tableData = [];
      }).finally(function () {
        _this.reqLoading = false;
      });
    },
    // 纯前端内存分页渲染逻辑
    renderCurrentPageData: function renderCurrentPageData() {
      var start = (this.searchData.page - 1) * this.searchData.limit;
      var end = start + this.searchData.limit;
      this.tableData = this.allTableData.slice(start, end);
      this.hasMore = this.allTableData.length > end;
    },
    changePage: function changePage(targetPage) {
      if (targetPage < 1) return;
      this.searchData.page = targetPage;
      this.renderCurrentPageData();
    },
    // 切换单页条数事件
    sizeChange: function sizeChange(val) {
      this.searchData.limit = val;
      this.searchData.page = 1;
      this.renderCurrentPageData();
    }
  }
};